// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__104MN","options":"AnswerScale_options__1il9H","selected":"AnswerScale_selected__1plIV"};